'use client'
import {useMediaQuery} from "@mui/material";


export const useDeviceDetect = () => {
  const isClient = typeof window !== 'undefined';
  const isTouchDevice = isClient ? matchMedia('(pointer: coarse)').matches : false;
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('md'));
  return isTouchDevice && isSmallScreen;
};
export default useDeviceDetect